import { render, staticRenderFns } from "./courseListLiananzhong.vue?vue&type=template&id=eba26dd6"
import script from "./courseListLiananzhong.vue?vue&type=script&lang=js"
export * from "./courseListLiananzhong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports